import Icon from '@/components/ui/AppIcon';

interface ContactOption {
  icon: string;
  title: string;
  description: string;
  action: string;
  actionIcon: string;
}

const ContactOptions = () => {
  const contactOptions: ContactOption[] = [
    {
      icon: 'PhoneIcon',
      title: 'Call Us Directly',
      description: 'Speak with our team for immediate assistance',
      action: '(236) 867-2004',
      actionIcon: 'PhoneIcon',
    },
    {
      icon: 'EnvelopeIcon',
      title: 'Email Us',
      description: 'Send us your questions and we\'ll respond within 24 hours',
      action: 'crystalcleanextr@gmail.com',
      actionIcon: 'EnvelopeIcon',
    },
  ];

  return (
    <div className="space-y-4">
      <h3 className="font-serif text-xl font-semibold text-foreground mb-4">
        Other Ways to Contact Us
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {contactOptions.map((option, index) => (
          <div
            key={index}
            className="bg-card border border-border rounded-lg p-6 hover:border-primary transition-smooth"
          >
            <div className="flex items-center justify-center w-12 h-12 bg-accent rounded-lg mb-4">
              <Icon name={option.icon as any} size={24} className="text-primary" />
            </div>
            <h4 className="font-semibold text-foreground mb-2">{option.title}</h4>
            <p className="text-sm text-muted-foreground mb-4">{option.description}</p>
            <button className="flex items-center text-sm font-medium text-primary hover:text-primary/80 transition-smooth">
              <Icon name={option.actionIcon as any} size={16} className="mr-2" />
              {option.action}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContactOptions;